var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit_Outline",
    transform: "translate(0 -0.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M22.936,52.278a.619.619,0,0,0-.619.619v5.494a1.858,1.858,0,0,1-1.857,1.856H3.094a1.858,1.858,0,0,1-1.857-1.856V42.266A1.859,1.859,0,0,1,3.094,40.41h5.5a.619.619,0,1,0,0-1.238h-5.5A3.1,3.1,0,0,0,0,42.266V58.391a3.1,3.1,0,0,0,3.094,3.094H20.46a3.1,3.1,0,0,0,3.094-3.094V52.9A.619.619,0,0,0,22.936,52.278Zm0,0",
    transform: "translate(0 -36.224)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M126.727,1.171a3.108,3.108,0,0,0-4.395,0l-12.32,12.32a.69.69,0,0,0-.177.3l-1.62,5.849a.69.69,0,0,0,.85.85l5.849-1.62a.69.69,0,0,0,.3-.177l12.32-12.32a3.111,3.111,0,0,0,0-4.395ZM111.517,13.94,121.6,3.856l3.252,3.252L114.768,17.191Zm-.65,1.3,2.6,2.6-3.594,1ZM126.561,5.4l-.732.732-3.252-3.252.733-.732a1.726,1.726,0,0,1,2.441,0l.811.81a1.729,1.729,0,0,1,0,2.442Zm0,0",
    transform: "translate(-103.446)",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOutline);
export default __webpack_public_path__ + "static/media/Edit_Outline.e50b26b605a10bad544a555744fed567.svg";
export { ForwardRef as ReactComponent };